import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ProcessInProgress, useNotifierContext } from '@oh-vcp/components-ui';
import { logUtils } from '@oh-vcp/components-common';
import { useAuth } from './AuthContext';
import { useEconsultCaseDetailsContext } from '../econsultCaseDetailsContext/EconsultCaseDetailsContext';
import CaseService from '../services/caseService';

const LoginCallback = () => {
  const { user, handleAndValidateToken } = useAuth();
  const { setFhirPatientGuid, setFhirContext, fhirPatientGuid, fhirContext } =
    useEconsultCaseDetailsContext();
  const { addNotification, removeAllErrorNotifications } = useNotifierContext();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const searchParams = new URLSearchParams(window.location.search);
  const viewCaseFhirId = searchParams.get('pluri')?.match(/^viewcase\/([^/]+)$/i)?.[1];
  const viewCaseHandled = useRef(false);
  handleAndValidateToken(!viewCaseFhirId);

  useEffect(() => {
    if (!user || !viewCaseFhirId || viewCaseHandled.current) {
      return;
    }
    viewCaseHandled.current = true;
    const openViewCase = async () => {
      try {
        const caseId = await CaseService.getCaseIdByFhirId(viewCaseFhirId);
        if (caseId) {
          navigate(`/case/search/${caseId}/${caseId}`);
          return;
        }
      } catch (error) {
        logUtils.logger.error('Failed to look up case id for fhir id:', viewCaseFhirId, error);
      }
      removeAllErrorNotifications();
      addNotification({
        type: 'error',
        message: t('Case.consult.errorLoadingCase'),
        solution: t('Case.consult.errorLoadingCaseSolution') as string
      });
      navigate('/case/search');
    };
    openViewCase();
  }, [user, viewCaseFhirId]);

  useEffect(() => {
    if (setFhirPatientGuid) {
      const fhirPatientGuid = searchParams.get('patient');
      setFhirPatientGuid(fhirPatientGuid || undefined);
    }
  }, [setFhirPatientGuid]);

  useEffect(() => {
    if (setFhirContext) {
      const fhirContext = searchParams.get('fhirContext');
      setFhirContext(fhirContext || undefined);
    }
  }, [setFhirContext]);

  useEffect(() => {
    if (fhirPatientGuid || fhirContext) {
      sessionStorage.setItem('integration', 'halo');
    } else {
      sessionStorage.removeItem('integration');
    }
  });

  const access_token = searchParams.get('access_token');
  if (access_token) {
    sessionStorage.setItem('token', access_token);
  }

  const refresh_token = searchParams.get('refresh_token');
  if (refresh_token) {
    sessionStorage.setItem('refreshToken', refresh_token);
  }

  return <ProcessInProgress title={t('loginInProgress')} />;
};

export default LoginCallback;
